export enum WalletTransactionType {
  Deposit = "DEPOSIT",
  Withdraw = "WITHDRAW",
  Subscription = "SUBSCRIPTION",
  FeePerTrade = "FEE-SUBSCRIPTION",
  ReferralReward = "REFERRAL-REWARD-CASHBACK"
}

export function mapWalletTransactionTypeName(type: WalletTransactionType) {
  switch (type) {
    case WalletTransactionType.Deposit: return "Deposit";
    case WalletTransactionType.Withdraw: return "Withdrawal";
    case WalletTransactionType.Subscription: return "Fixed-Price Subscription";
    case WalletTransactionType.FeePerTrade: return "🪐 Pay As You Go Fee";
    case WalletTransactionType.ReferralReward: return "Referral Reward";
    default: return type;
  }
}

export default class WalletTransaction {
  constructor(
    public date: number,
    public type: WalletTransactionType,
    public amount: number,
    public fee: number
  ) { }
}
